import { render, staticRenderFns } from "./CO3.vue?vue&type=template&id=63884615&scoped=true&"
import script from "./CO3.vue?vue&type=script&lang=js&"
export * from "./CO3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63884615",
  null
  
)

export default component.exports